import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useLoaderData } from 'react-router-dom';

import Location from '@r6digital/rapidstor-types/react/entities/Location';

import Navbar from '../components/Navbar';
import RapidStor from '../components/RapidStor';

function RapidStorPage() {
    const location = useLoaderData() as Location;

    return (
        <>
            <Row>
                <Col xs={12}>
                    <Navbar label='Secure Booking' hideSelectors finalPage />
                    <RapidStor location={location} />
                </Col>
            </Row>
        </>
    );
}

export default RapidStorPage;
